import { useContext, useRef, useEffect } from "react";
import { GlobalContext } from "@/context/GlobalContext";

const useWeightModal = () => {
	const { modalRef } = useContext(GlobalContext);
	const { modalProduct, setModalProduct } = useContext(GlobalContext);

	const toggleModal = () => {
		if (modalRef.current?.open) {
			modalRef.current?.close();
			document.body.classList.remove("no-scroll");
			return;
		}
		document.body.classList.add("no-scroll");
		modalRef.current?.showModal();
		
	};

	const closeModal = () => {
		modalRef.current?.close();
		document.body.classList.remove("no-scroll");
	};

	const showModal = () => {
		document.body.classList.add("no-scroll");
		modalRef.current?.showModal();
	};

	return {
		modalRef,
		modalProduct,
		setModalProduct,
		toggleModal,
		closeModal,
		showModal,
	};
};
export default useWeightModal;